module.exports = __webpack_public_path__ + "static/media/VIN_Car_Img.41f64ee7.png";